import React, { useEffect, useState } from "react";
import LeadsMainPage from "../../partners/leads/LeadsMainPage";
import { API_URL, authFetch } from "../../utils/auth";

export default function Leads() {
  const [leads, setLeads] = useState([]);
  const [metrics, setMetrics] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    async function loadLeads() {
      try {
        const response = await authFetch(`${API_URL}/partner/leads/`);
        const data = await response.json();
        if (!response.ok) throw new Error(data.detail || "Failed to load leads");
        setLeads(Array.isArray(data) ? data : data.results || []);
        setMetrics(Array.isArray(data) ? {} : data.metrics || {});
      } catch (err) {
        console.error(err);
        setError(err.message || "Failed to load leads");
      } finally {
        setLoading(false);
      }
    }

    loadLeads();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return <LeadsMainPage leads={leads} metrics={metrics} />;
}